import { useState } from "react";
import { Button, Col, Form, FormControl, Row } from "react-bootstrap";
import { postFeedback } from "../../services/ledgerService";


export default function FeedbackPage() {
    const [feedback, setFeedback] = useState("");
    const [name, setName] = useState("");
    const [status, setStatus] = useState(null);

    const handleSubmit = async (event) => {
        event.preventDefault();

        try {
            await postFeedback({ feedback, name });
            setStatus({ message: "Feedback submitted successfully!", error: false });
            setFeedback("");
        } catch (error) {
            console.error("Error submitting feedback:", error);
            setStatus({ message: "Error submitting feedback. Please try again.", error: true });
        }
    }

    const buttonDisabled = feedback.length < 10 || name.length < 2 || (status !== null && status.error === false);

    return (
        <Row className="feedback">
            <Col xs={12} md={6} className="mx-auto mt-5 p-3 shadow-sm">
                <Form method="post" onSubmit={handleSubmit}>
                    <h1>Feedback</h1>
                    <p>Do you have any suggestions for improvement? Please let us know, we value your feedback!</p>
                    <FormControl 
                        name="name"
                        className="mb-3"
                        type="text"
                        placeholder="Your first name" 
                        onChange={(e) => setName(e.target.value)}
                        required
                    />
                    <FormControl 
                        name="feedback" 
                        className="mb-3"
                        as="textarea"
                        rows={5}
                        placeholder="Enter your feedback here..." 
                        onChange={(e) => setFeedback(e.target.value)}
                        required
                    />
                    <Button type="submit" disabled={buttonDisabled} variant="success">Submit Feedback</Button>
                    {status 
                        ? <Row className="pt-3"><Col xs={12}><p className={status.error ? "text-danger" : "text-success"}>{status.message}</p></Col></Row>
                        : <></>
                    }
                </Form>
            </Col>
        </Row>
    );
}
